import { Container, makeStyles, Box } from '@material-ui/core'
import { useState, useEffect } from 'react'

import { ContentHeader, Page } from 'components'
import AccountsForm from './components/AccountsForm'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import { useHistory, useParams } from 'react-router-dom'

import styles from './styles'
import * as service from 'service'
import { routes } from 'Routes'

const useStyles = makeStyles(styles)

const AccountsEdit = () => {
  const classes = useStyles()
  const { accountId } = useParams()
  const history = useHistory()
  const snackbar = useSnackbar()
  const [isSaving, setIsSaving] = useState(false)

  const { response, isLoading } = useFetch(
    service.intermediador.accounts.show,
    accountId,
    [accountId],
  )
  const { response: responsePriceTables, isLoading: isLoadingPriceTables } =
    useFetch(service.intermediador.priceTables.get, {
      perPage: 10000,
      status: 'ACTIVE',
    })

  // Debug: Log the price tables data
  console.log(
    'AccountsEdit - PriceTables:',
    responsePriceTables?.data?.priceTables,
  )

  // Debug: Log the response data
  console.log('AccountsEdit - Response:', response)
  console.log('AccountsEdit - IsLoading:', isLoading)

  // Map the response data to form fields - only editable fields
  const initial = {
    documentType: 'CNPJ', // Default to CNPJ since we have cnpj field
    document: response?.data?.account?.cnpj || '',
    fantasyName: response?.data?.account?.fantasyName || '',
    companyName: response?.data?.account?.companyName || '',
    institutionalEmail: response?.data?.account?.institutionalEmail || '',
    url: response?.data?.account?.url || '',
    businessCategory: response?.data?.account?.businessCategory || '',
    monthlyBillingRange: response?.data?.account?.monthlyBillingRange || '',
    priceTableId: response?.data?.account?.priceTableId || '',
    // Additional fields that might be in the API response
    softDescription: response?.data?.account?.softDescription || '',
    partnerGroup: response?.data?.account?.partnerGroup || '',
    mcc: response?.data?.account?.mcc || '',
    reprovalReason: response?.data?.account?.reprovalReason || '',
  }

  // Debug: Log the mapped initial data
  console.log('AccountsEdit - Initial data:', initial)

  const handleUpdate = async (data) => {
    console.log('🔴 AccountsEdit - handleUpdate called with data:', data)
    console.log('🔴 AccountsEdit - accountId:', accountId)

    setIsSaving(true)
    try {
      const updatePayload = {
        accountId,
        name: data.companyName,
        cnpj: data.document,
        fantasy_name: data.fantasyName,
        company_name: data.companyName,
        institutional_email: data.institutionalEmail?.trim()?.toLowerCase(),
        url: data.url,
        business_category: data.businessCategory,
        monthly_billing_range: data.monthlyBillingRange,
        price_table_id: data.priceTableId,
        soft_description: data.softDescription || '',
        status: response?.data?.account?.status || 'pending',
        partner_group: data.partnerGroup || '',
        mcc: data.mcc || '',
        reproval_reason: data.reprovalReason || '',
      }

      const res = await service.intermediador.accounts.update(updatePayload)

      snackbar.open({
        message: `Cliente atualizado com sucesso`,
        variant: 'success',
      })

      history.push({
        pathname: routes.accounts.show.replace(':accountId', accountId),
      })
    } catch (error) {
      console.error('AccountsEdit - Update error:', error)
      console.error('AccountsEdit - Error details:', error.response?.data)

      snackbar.open({
        message: `Erro ao atualizar cliente: ${
          error.response?.data?.message || error.message
        }`,
        variant: 'error',
      })
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <Page title="Editar cliente">
      <Container maxWidth={false} className={classes.rootNew}>
        <ContentHeader menu="Clientes" title="Editar" subtitle="Cliente" />
        <Box mt={6}>
          {isLoading ? (
            <div>Carregando dados...</div>
          ) : (
            <AccountsForm
              priceTables={responsePriceTables?.data?.priceTables}
              defaultValues={initial}
              onSubmit={handleUpdate}
              isLoading={isSaving}
              isEdit={true}
            />
          )}
        </Box>
      </Container>
    </Page>
  )
}

export default AccountsEdit
